import RecTableService from '../../service/RecTableService'

const newRec = {
    index: null,
    etText: null,
    etDisclaimer: null,
    etInfoLabel: null,
    type: null,
}

const initialState = {
    tableData: [],
    newRec: { ...newRec },
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async fetchRecTableData({ commit }) {
            try {
                const resp = await RecTableService.get()
                if (resp.status === 200) {
                    commit('setTableData', resp.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async editRec({ dispatch }, newData) {
            try {
                const resp = await RecTableService.put(newData)
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Recommendation updated',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }
        },
        async deleteRec({ dispatch, commit }, recID) {
            try {
                const resp = await RecTableService.delete(recID)
                if (resp.status === 200) {
                    commit('resetNewRecommendation')
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Recommendation deleted',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }
        },
        async handleNewRecClick({ state, commit, dispatch }) {
            try {
                const resp = await RecTableService.createRecommendation(state.newRec)
                if (resp.status === 201) {
                    commit('resetNewRecommendation')
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'New recommendation created',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }
        },
    },
    mutations: {
        setTableData(state, data) {
            state.tableData = data
        },
        resetNewRecommendation(state) {
            state.newRec = {}
        },
    },
    getters: {},
}
